import { DailyPhaseName, TaskLinkType, TaskPhaseName } from './task.enum';
import { LabelEntity, LabelType } from '../shared/label';
import { LexoRank } from '../shared/lexorank';
import * as Enumerable from 'linq';
import { Task } from './task';
import { Entity } from '../entity';
import { TaskLinkEntity } from './task.props.type';

// remove build crash
export const BeforePhase = { _id: '00000000-0000-0000-0000-000000000001', name: TaskPhaseName.Before, sortOrder: new LexoRank('1').toString(), type: TaskLinkType.Phase };
export const DuringPhase = { _id: '00000000-0000-0000-0000-000000000002', name: TaskPhaseName.During, sortOrder: new LexoRank('2').toString(), type: TaskLinkType.Phase };
export const AfterPhase = { _id: '00000000-0000-0000-0000-000000000003', name: TaskPhaseName.After, sortOrder: new LexoRank('3').toString(), type: TaskLinkType.Phase };


export const CheckInPhase = { _id: '00000000-0000-0000-0000-000000000100', name: DailyPhaseName.CheckIn, sortOrder: new LexoRank('1').decrement().toString(), type: TaskLinkType.Phase };
export const CheckOutPhase = { _id: '00000000-0000-0000-0000-000000000101', name: DailyPhaseName.CheckOut, sortOrder: new LexoRank('3').increment().toString(), type: TaskLinkType.Phase };

export function getNoTaskGroupLink(groupName: string) {
    return { _id: '00000000-0000-0000-0000-000000001000', name: groupName, sortOrder: new LexoRank('100001', '0').toString(), type: TaskLinkType.Group } as TaskLinkEntity;
};

export function getEntityTaskLink(entity: Entity, type: TaskLinkType) {
    return { ...entity, sortOrder: new LexoRank('1').toString(), type } as TaskLinkEntity;
};


export type HasTags = {
    tags?: LabelEntity[];
}

export function insertPhaseTag(task: HasTags, phase: TaskPhaseName | string) {

    if (!phase)
        return task?.tags ?? [];

    const taskTags = task?.tags ?? [];
    const tags = phase
        ? [...taskTags, getPhaseTag(phase)]
        : taskTags;

    const safeTags = Enumerable
        .from(tags)
        .distinct(x => {
            return `${x._id}-${x.type}`;
        })
        .toArray();

    return safeTags;

    // return { _id: phase, name: phase, type: LabelType.Phase } as LabelEntity
}

export function getPhaseTag(phase: string) {
    const phaseTag = { _id: phase, name: phase, type: LabelType.Phase } as LabelEntity;
    return phaseTag;
}

export const JobTaskPhases = [
    CheckInPhase,
    BeforePhase,
    DuringPhase,
    AfterPhase,
    CheckOutPhase
];

export class TaskUtility {

    public static getDefaultPhase(key: string) {
        return JobTaskPhases.find(x => x.name === key || x._id === key);
    }

    /// Need to update fallback values if integrate task within another module. e.g Opportunity
    public static getTaskLink(task: Partial<Task>): TaskLinkEntity {
        const linkGroups = Enumerable
            .from(task.links)
            .groupBy(x => x.type)
            .toDictionary(x => x.key(), x => x.firstOrDefault());


        // Don't really understand this logic ~.~ Just trying to make it work for Job-Pro
        const type = linkGroups.get(TaskLinkType.WorkOrder)
            ?? linkGroups.get(TaskLinkType.Job)
            ?? linkGroups.get(TaskLinkType.Opportunity)
            ?? linkGroups.get(TaskLinkType.Work)
            ?? linkGroups.get(TaskLinkType.Contact);
        return type;
    }
}